import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Calendar, Flag, Smile, LogOut, Printer } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/app/planner", label: "Planner",   icon: Calendar, testid: "nav-planner" },
  { to: "/app/goals",   label: "Goals",     icon: Flag,     testid: "nav-goals" },
  { to: "/app/mood",    label: "How I feel",icon: Smile,    testid: "nav-mood" },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <header className="no-print sticky top-0 z-30 bg-white border-b border-slate-200">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/app/planner" className="flex items-center gap-2" data-testid="brand-link">
            <div className="w-8 h-8 rounded-xl bg-amber-400 flex items-center justify-center text-white font-bold">W</div>
            <span className="font-heading font-bold text-lg text-slate-800">My Week</span>
          </Link>

          <nav className="hidden sm:flex items-center gap-1">
            {NAV.map(({ to, label, icon: Icon, testid }) => {
              const active = location.pathname === to || (to === "/app/planner" && location.pathname === "/app");
              return (
                <Link
                  key={to}
                  to={to}
                  data-testid={testid}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                    active ? "bg-amber-100 text-amber-900" : "text-slate-600 hover:bg-slate-100"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <span className="hidden md:inline text-sm text-slate-600" data-testid="user-greeting">Hi, {user?.name}</span>
            <Button
              variant="outline"
              size="sm"
              className="rounded-full"
              data-testid="print-view-btn"
              onClick={() => nav("/print")}
            >
              <Printer className="w-4 h-4 mr-1" /> Print
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="rounded-full"
              data-testid="logout-btn"
              onClick={async () => { await logout(); nav("/"); }}
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {/* Mobile tabs */}
        <div className="sm:hidden border-t border-slate-100 flex">
          {NAV.map(({ to, label, icon: Icon, testid }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                data-testid={`${testid}-mobile`}
                className={`flex-1 flex items-center justify-center gap-1 py-2 text-xs font-medium ${
                  active ? "text-amber-700 bg-amber-50" : "text-slate-600"
                }`}
              >
                <Icon className="w-4 h-4" /> {label}
              </Link>
            );
          })}
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
